import { isNonEmpty } from 'fp-ts/Array';
import { keepPreviousData } from '@tanstack/react-query';
import { GeneralArea, useRepositoryQuery } from '@mews-commander/data-access';

export const useGeneralEnterprisesByIds = (enterpriseIds: string[] | null) =>
    useRepositoryQuery(
        'generalEnterprises',
        'getAll',
        { enterpriseIds, application: GeneralArea.Commander, extent: { cities: true } },
        {
            placeholderData: keepPreviousData,
            enabled: !!enterpriseIds && isNonEmpty(enterpriseIds),
        }
    );
